var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "divBox" }, [
    _vm.checkBtn
      ? _c(
          "div",
          [
            _c(
              "el-card",
              {
                staticClass: "normal-page p20",
                staticStyle: { "padding-bottom": "0" },
              },
              [
                _c(
                  "div",
                  { staticClass: "flex-between" },
                  [
                    _c("div", { staticClass: "title-16" }, [
                      _vm._v("审批列表"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "hasPermi",
                            rawName: "v-hasPermi",
                            value: ["business:examine:index:add"],
                            expression: "['business:examine:index:add']",
                          },
                        ],
                        attrs: {
                          type: "primary",
                          size: "small",
                          icon: "el-icon-plus",
                        },
                        on: {
                          click: function ($event) {
                            _vm.checkBtn = !_vm.checkBtn
                            _vm.mockData = {}
                            _vm.activeName = "basicSetting"
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("business.addBusiness")) +
                            "\n        "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "total-16 mb10 mt20" }, [
                  _vm._v("共 " + _vm._s(_vm.total) + " 条"),
                ]),
                _vm._v(" "),
                _vm.tableData.length > 0
                  ? _c(
                      "div",
                      [
                        _c(
                          "el-table",
                          {
                            directives: [
                              {
                                name: "loading",
                                rawName: "v-loading",
                                value: _vm.loading,
                                expression: "loading",
                              },
                            ],
                            attrs: {
                              data: _vm.tableData,
                              height: _vm.tableHeight1,
                            },
                          },
                          [
                            _c("el-table-column", {
                              attrs: {
                                prop: "name",
                                label: _vm.$t("business.businessType"),
                                "min-width": "230",
                                "show-overflow-tooltip": "",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c("div", { staticClass: "flex" }, [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "selIcon",
                                              style: {
                                                backgroundColor:
                                                  scope.row.color,
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "icon iconfont",
                                                class: scope.row.icon,
                                              }),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("div", { staticClass: "ml10" }, [
                                            _vm._v(
                                              _vm._s(scope.row.name || "--")
                                            ),
                                          ]),
                                        ]),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                3818363198
                              ),
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "refuse",
                                label: _vm.$t("business.Range"),
                                "min-width": "200",
                                "show-overflow-tooltip": "",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        scope.row.process &&
                                        scope.row.process.info.depList.length <=
                                          0 &&
                                        scope.row.process.info.userList
                                          .length <= 0
                                          ? _c("span", [
                                              _vm._v(
                                                "\n                所有人\n              "
                                              ),
                                            ])
                                          : _c(
                                              "div",
                                              { staticClass: "refuse-info" },
                                              [
                                                scope.row.process
                                                  ? _c(
                                                      "div",
                                                      [
                                                        _vm._l(
                                                          scope.row.process.info
                                                            .depList,
                                                          function (item) {
                                                            return _c(
                                                              "span",
                                                              { key: item.id },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    item.name
                                                                  )
                                                                ),
                                                              ]
                                                            )
                                                          }
                                                        ),
                                                        _vm._v(" "),
                                                        _vm._l(
                                                          scope.row.process.info
                                                            .userList,
                                                          function (item) {
                                                            return _c(
                                                              "span",
                                                              { key: item.id },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    item.card
                                                                      ? item
                                                                          .card
                                                                          .name
                                                                      : item.name
                                                                  )
                                                                ),
                                                              ]
                                                            )
                                                          }
                                                        ),
                                                      ],
                                                      2
                                                    )
                                                  : _vm._e(),
                                              ]
                                            ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                1499262830
                              ),
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "updated_at",
                                label: _vm.$t("toptable.updatetime"),
                                "min-width": "110",
                                "show-overflow-tooltip": "",
                              },
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                label: _vm.$t("hr.state"),
                                width: "160",
                                "show-overflow-tooltip": "",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c("el-switch", {
                                          attrs: {
                                            "active-text": _vm.$t("hr.open"),
                                            "inactive-text": _vm.$t("hr.close"),
                                            "active-value": 1,
                                            "inactive-value": 0,
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.handleStatus(scope.row)
                                            },
                                          },
                                          model: {
                                            value: scope.row.status,
                                            callback: function ($$v) {
                                              _vm.$set(scope.row, "status", $$v)
                                            },
                                            expression: "scope.row.status",
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                3652197053
                              ),
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                label: "操作",
                                width: "200",
                                "show-overflow-tooltip": "",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-button",
                                          {
                                            directives: [
                                              {
                                                name: "hasPermi",
                                                rawName: "v-hasPermi",
                                                value: [
                                                  "business:examine:index:edit",
                                                ],
                                                expression:
                                                  "['business:examine:index:edit']",
                                              },
                                            ],
                                            attrs: { type: "text" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.handleEdit(scope.row)
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("public.edit"))
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-button",
                                          {
                                            directives: [
                                              {
                                                name: "hasPermi",
                                                rawName: "v-hasPermi",
                                                value: [
                                                  "business:examine:index:delete",
                                                ],
                                                expression:
                                                  "['business:examine:index:delete']",
                                              },
                                            ],
                                            attrs: { type: "text" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.handleDelete(
                                                  scope.row
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("public.delete"))
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                2084800080
                              ),
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "page-fixed" },
                          [
                            _c("el-pagination", {
                              attrs: {
                                "page-size": _vm.where.limit,
                                "current-page": _vm.where.page,
                                "page-sizes": [15, 20, 30],
                                layout:
                                  "total, sizes,prev, pager, next, jumper",
                                total: _vm.total,
                              },
                              on: {
                                "size-change": _vm.handleSizeChange,
                                "current-change": _vm.pageChange,
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _c(
                      "div",
                      [
                        _c("default-page", {
                          directives: [{ name: "height", rawName: "v-height" }],
                          attrs: { index: 14, "min-height": 520 },
                        }),
                      ],
                      1
                    ),
              ]
            ),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    !_vm.checkBtn
      ? _c(
          "div",
          { staticClass: "examineBox" },
          [
            _c(
              "el-card",
              { staticClass: "examineCard" },
              [
                _c(
                  "el-row",
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-page-header",
                          { attrs: { content: "添加审批流程页面" } },
                          [
                            _c(
                              "div",
                              {
                                attrs: { slot: "title" },
                                on: {
                                  click: function ($event) {
                                    _vm.checkBtn = true
                                  },
                                },
                                slot: "title",
                              },
                              [
                                _c("i", { staticClass: "el-icon-arrow-left" }),
                                _vm._v("\n              返回\n            "),
                              ]
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 16 } },
                      [
                        _c(
                          "el-tabs",
                          {
                            staticClass: "examineTabs",
                            on: {
                              "tab-click": function ($event) {
                                return _vm.handleClick(_vm.activeName)
                              },
                            },
                            model: {
                              value: _vm.activeName,
                              callback: function ($$v) {
                                _vm.activeName = $$v
                              },
                              expression: "activeName",
                            },
                          },
                          _vm._l(_vm.tabArray, function (item, index) {
                            return _c(
                              "el-tab-pane",
                              { key: index, attrs: { name: item.value } },
                              [
                                _c(
                                  "div",
                                  { attrs: { slot: "label" }, slot: "label" },
                                  [
                                    _c("span", { staticClass: "sp1" }, [
                                      _vm._v(_vm._s(item.number)),
                                    ]),
                                    _vm._v(" "),
                                    _c("span", [_vm._v(_vm._s(item.label))]),
                                  ]
                                ),
                              ]
                            )
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "mt14 card-box" },
              [
                _c("basic-setting", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.activeName === "basicSetting",
                      expression: "activeName === 'basicSetting'",
                    },
                  ],
                  ref: "basicSetting",
                  attrs: {
                    "tab-name": "basicSetting",
                    conf: _vm.mockData.baseConfig,
                  },
                }),
                _vm._v(" "),
                _c("form-setting", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.activeName === "formSetting",
                      expression: "activeName === 'formSetting'",
                    },
                  ],
                  ref: "formSetting",
                  attrs: {
                    "tab-name": "formSetting",
                    conf: _vm.mockData.formConfig,
                  },
                }),
                _vm._v(" "),
                _c("rule-setting", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.activeName === "ruleSetting",
                      expression: "activeName === 'ruleSetting'",
                    },
                  ],
                  ref: "ruleSetting",
                  attrs: {
                    "tab-name": "ruleSetting",
                    conf: _vm.mockData.ruleConfig,
                  },
                }),
                _vm._v(" "),
                _c("process-setting", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.activeName === "processSetting",
                      expression: "activeName === 'processSetting'",
                    },
                  ],
                  ref: "processSetting",
                  attrs: {
                    "tab-name": "processSetting",
                    conf: _vm.mockData.processConfig,
                  },
                }),
              ],
              1
            ),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    !_vm.checkBtn
      ? _c(
          "div",
          { staticClass: "cr-bottom-button btn-shadow" },
          [
            _vm.activeName !== "basicSetting"
              ? _c(
                  "el-button",
                  { attrs: { size: "small" }, on: { click: _vm.previousStep } },
                  [_vm._v("上一步")]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.activeName !== "ruleSetting"
              ? _c(
                  "el-button",
                  { attrs: { size: "small" }, on: { click: _vm.nextStep } },
                  [_vm._v("下一步")]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "el-button",
              {
                attrs: { type: "primary", size: "small" },
                on: { click: _vm.publish },
              },
              [_vm._v("发布")]
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }